import {Component, computed, inject, input, output, ChangeDetectionStrategy} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';


import {BreakpointObserver} from "@angular/cdk/layout";
import {AuthenticationService} from "src/app/services/auth/authentication.service";
import {HOME_URL} from "src/app/models/home/navigation.model";
import {Router} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {IconButtonComponent} from 'src/app/modules/design-system/icon-button/icon-button.component';
import {TextButtonComponent} from 'src/app/modules/design-system/text-button/text-button.component';

@Component({
  selector: 'app-onboarding-step-1',
  standalone: true,
	imports: [IconButtonComponent, TextButtonComponent, TranslatePipe],
  templateUrl: './onboarding-step-1.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../onboarding.component.scss'
})
export class OnboardingStep1Component {
	private router = inject(Router);

	readonly stepCount = input.required<number>();
	readonly canClose = input(false);
	readonly isMobile = input.required<boolean>();

	readonly onNextClick = output<string>();

	protected readonly currentUser = inject(AuthenticationService).getUserInfo()!;

	private readonly compact = toSignal(inject(BreakpointObserver).observe(['(max-width: 1280px)']).pipe(map(state => state.matches)), {initialValue: false});
	protected readonly panelClass = computed(() => this.compact() ? '' : 'big-button');

	goBackHome() {
		return this.router.navigate([HOME_URL])
	}
}
